import { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Minus } from "lucide-react";
import { SERVICES } from "../lib/content";
import { Reveal, MaskReveal } from "../components/Reveal";

export default function Services() {
  const [open, setOpen] = useState(SERVICES[0].slug);

  return (
    <div className="pt-32 md:pt-40 pb-24" data-testid="services-page">
      <section className="container-edge">
        <div className="overline text-ink/60">Index — Disciplines</div>
        <MaskReveal delay={0.05}>
          <h1 className="font-display uppercase text-7xl md:text-[12vw] leading-[0.82] mt-4">
            Nine houses<br/>under <span className="serif-italic font-serif normal-case">one roof</span>.
          </h1>
        </MaskReveal>
        <Reveal delay={0.3}>
          <p className="mt-8 max-w-2xl text-lg md:text-xl text-ink/80 font-light">
            Engage a single division — or commission the entire studio. Our retainers are reserved for women whose work, once seen, is never forgotten.
          </p>
        </Reveal>
      </section>

      <section className="container-edge mt-20 md:mt-28">
        <div className="border-t border-ink/20">
          {SERVICES.map((s) => {
            const isOpen = open === s.slug;
            return (
              <div key={s.slug} className="relative border-b border-ink/20 overflow-hidden" data-testid={`service-row-${s.slug}`}>
                <div className="relative z-10">
                <button
                  onClick={() => setOpen(isOpen ? null : s.slug)}
                  className="w-full flex items-baseline gap-6 md:gap-10 py-8 md:py-12 text-left group"
                  data-testid={`service-toggle-${s.slug}`}
                >
                  <span className="overline text-ink/50 w-10 shrink-0">{s.number}</span>
                  <span className="font-display uppercase text-5xl md:text-8xl leading-[0.9] flex-1 group-hover:text-ink/70 transition-colors">
                    {s.name}
                  </span>
                  <span className="hidden md:block serif-italic font-serif text-2xl text-ink/60 max-w-xs text-right">
                    {s.short}
                  </span>
                  <span className="ml-3">{isOpen ? <Minus size={22} /> : <Plus size={22} />}</span>
                </button>

                <div
                  className={`grid transition-all duration-700 ease-out ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
                >
                  <div className="overflow-hidden">
                    <div className="pb-12 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-3 md:pl-16">
                      {s.items.map((item) => (
                        <div key={item} className="flex items-center gap-4 py-2 border-b border-ink/10">
                          <span className="overline text-ink/40">✦</span>
                          <span className="font-serif text-xl md:text-2xl">{item}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="container-edge mt-32 grid grid-cols-12 gap-6 items-end">
        <div className="col-span-12 md:col-span-7">
          <h2 className="font-display uppercase text-6xl md:text-8xl leading-[0.85]">
            Not sure where to start?<br/><span className="serif-italic font-serif normal-case">Begin with the application</span>.
          </h2>
        </div>
        <div className="col-span-12 md:col-span-5">
          <p className="text-ink/75 text-lg leading-relaxed">
            We don&apos;t quote without context. Engagements begin at <span className="text-ink font-medium">$7,000/month</span> and scale to <span className="text-ink font-medium">$250,000/month</span> for full-studio retainers. Submit an application — we&apos;ll review and respond within 21 business days with a tailored direction, the right divisions, and a fit.
          </p>
          <Link to="/apply" className="btn-ink mt-8 inline-flex" data-testid="services-cta">Begin the application →</Link>
        </div>
      </section>
    </div>
  );
}
